import { LocaleCode } from 'transloco.config';
import { availableLocales } from './available-locales';

export const availableLocaleCodes: LocaleCode[] = availableLocales.map(
  (locale) => locale.code,
);
